import { render, staticRenderFns } from "./LandingPageInzerce.vue?vue&type=template&id=34723fc8&scoped=true&"
import script from "./LandingPageInzerce.vue?vue&type=script&lang=js&"
export * from "./LandingPageInzerce.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageInzerce.vue?vue&type=style&index=0&id=34723fc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34723fc8",
  null
  
)

export default component.exports